import {createApp} from 'vue'
import {createPinia} from 'pinia';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';
import Ripple from 'primevue/ripple';
import * as Sentry from "@sentry/vue";
import {LDPlugin} from 'launchdarkly-vue-client-sdk'

import 'v-calendar/style.css';
import 'primeicons/primeicons.css'
import '@/assets/main.css'
import '@/assets/transitions.css'

import hOS from './hOS.vue'
import {router} from './helpers'
import {setupCalendar} from 'v-calendar';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import StyleClass from "primevue/styleclass";
import Aura from '@primevue/themes/aura';

// import as directive
import BadgeDirective from 'primevue/badgedirective';
import {definePreset, palette} from "@primevue/themes";

import setup_components from "./primevue-components.js";
import FocusTrap from "primevue/focustrap";

// Use calendar defaults (optional)

const app = createApp(hOS);

Sentry.init({
    app,
    // @ts-ignore
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
});

// Initialize LaunchDarkly
const launchDarklyClientId = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID
if (launchDarklyClientId) {
    console.log('Initializing LaunchDarkly with client ID:', launchDarklyClientId)
    
    app.use(LDPlugin, {
        clientSideID: launchDarklyClientId
    })
    
    console.log('LaunchDarkly plugin loaded successfully')
} else {
    console.warn('LaunchDarkly client ID not found. Set VITE_LAUNCHDARKLY_CLIENT_ID environment variable.')
}


app.use(PrimeVue, {
    ripple: true,
    theme: {
        preset: definePreset(Aura, {
            semantic: {
                primary: palette('{blue}')
            }
        }),
        options: {
            darkModeSelector: '.dark',
        }
    },
});
app.config.errorHandler
app.use(ToastService);
app.use(ConfirmationService);

const pinia = createPinia();
app.use(pinia);

app.use(router)
app.use(setupCalendar, {})
setup_components(app)


app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);
app.directive('badge', BadgeDirective);
app.directive('styleclass', StyleClass);
app.directive('focustrap', FocusTrap);

app.mount('#app')
